import ErrorPage from './ErrorPage'

export default function UnknownUser() {
  return <ErrorPage message={"I'm sorry, but we don't recognize you."}/>
}
